/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  FundDetailResponse,
  GetFundAccountResponse,
  GetFundTransfersResponse,
  UtxFundApiFundTransferParams,
  GetFundCatalogListResponse,
  UtxFundApiFundSubscriptionParams,
  PostSubscriptionResponse,
  FundRequest,
  PendingSubscriptionResponse,
  RedemptionListResponse,
  CanRedemptionListResponse,
  FundAccountRequestResponse,
  FundAccountRequest,
  FundBondWmcAccountRequestResponse,
  FundBondWmcAccountRequest,
  CalcFeeForUserResponse,
  UtxFundApiCalcFeeForUserParams,
  WmcFundFilterResponse,
  UtxFundApiWmcFundFilterParams,
  SecuritiesBalanceListResponse,
  UtxFundApiSecuritiesBalanceForUserParams,
  CashPositionForSecuritiesBalanceListResponse,
  UtxFundApiGetSecuritiesBalanceForUserParams
} from './schema'



export const utxFundApiFundDetails = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FundDetailResponse>> => {
    return axios.get(
      `/Fund/catalog/${id}`,options
    );
  }


export const getUtxFundApiFundDetailsQueryKey = (id: string,) => [`/Fund/catalog/${id}`];

    
export type UtxFundApiFundDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiFundDetails>>>
export type UtxFundApiFundDetailsQueryError = AxiosError<unknown>

export const useUtxFundApiFundDetails = <TData = Awaited<ReturnType<typeof utxFundApiFundDetails>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiFundDetails>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiFundDetailsQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiFundDetails>>> = ({ signal }) => utxFundApiFundDetails(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiFundDetails>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFundApiFundAccounts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetFundAccountResponse>> => {
    return axios.get(
      `/Fund/accounts`,options
    );
  }


export const getUtxFundApiFundAccountsQueryKey = () => [`/Fund/accounts`];

    
export type UtxFundApiFundAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiFundAccounts>>>
export type UtxFundApiFundAccountsQueryError = AxiosError<unknown>

export const useUtxFundApiFundAccounts = <TData = Awaited<ReturnType<typeof utxFundApiFundAccounts>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiFundAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiFundAccountsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiFundAccounts>>> = ({ signal }) => utxFundApiFundAccounts({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiFundAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFundApiFundTransfer = (
    params?: UtxFundApiFundTransferParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetFundTransfersResponse>> => {
    return axios.get(
      `/Fund/transfer`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxFundApiFundTransferQueryKey = (params?: UtxFundApiFundTransferParams,) => [`/Fund/transfer`, ...(params ? [params]: [])];

    
export type UtxFundApiFundTransferQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiFundTransfer>>>
export type UtxFundApiFundTransferQueryError = AxiosError<unknown>

export const useUtxFundApiFundTransfer = <TData = Awaited<ReturnType<typeof utxFundApiFundTransfer>>, TError = AxiosError<unknown>>(
 params?: UtxFundApiFundTransferParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiFundTransfer>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiFundTransferQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiFundTransfer>>> = ({ signal }) => utxFundApiFundTransfer(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiFundTransfer>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFundApiFundSubscription = (
    params?: UtxFundApiFundSubscriptionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetFundCatalogListResponse>> => {
    return axios.get(
      `/Fund/catalog`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxFundApiFundSubscriptionQueryKey = (params?: UtxFundApiFundSubscriptionParams,) => [`/Fund/catalog`, ...(params ? [params]: [])];

    
export type UtxFundApiFundSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiFundSubscription>>>
export type UtxFundApiFundSubscriptionQueryError = AxiosError<unknown>

export const useUtxFundApiFundSubscription = <TData = Awaited<ReturnType<typeof utxFundApiFundSubscription>>, TError = AxiosError<unknown>>(
 params?: UtxFundApiFundSubscriptionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiFundSubscription>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiFundSubscriptionQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiFundSubscription>>> = ({ signal }) => utxFundApiFundSubscription(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiFundSubscription>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFundApiMakeFundSubscription = (
    fundRequest: FundRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostSubscriptionResponse>> => {
    return axios.post(
      `/Fund/subscription`,
      fundRequest,options
    );
  }



    export type UtxFundApiMakeFundSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof utxFundApiMakeFundSubscription>>>
    export type UtxFundApiMakeFundSubscriptionMutationBody = FundRequest
    export type UtxFundApiMakeFundSubscriptionMutationError = AxiosError<unknown>

    export const useUtxFundApiMakeFundSubscription = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxFundApiMakeFundSubscription>>, TError,{data: FundRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxFundApiMakeFundSubscription>>, {data: FundRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxFundApiMakeFundSubscription(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxFundApiMakeFundSubscription>>, TError, {data: FundRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxFundApiMakeFundRedemption = (
    fundRequest: FundRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostSubscriptionResponse>> => {
    return axios.post(
      `/Fund/redemption`,
      fundRequest,options
    );
  }



    export type UtxFundApiMakeFundRedemptionMutationResult = NonNullable<Awaited<ReturnType<typeof utxFundApiMakeFundRedemption>>>
    export type UtxFundApiMakeFundRedemptionMutationBody = FundRequest
    export type UtxFundApiMakeFundRedemptionMutationError = AxiosError<unknown>

    export const useUtxFundApiMakeFundRedemption = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxFundApiMakeFundRedemption>>, TError,{data: FundRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxFundApiMakeFundRedemption>>, {data: FundRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxFundApiMakeFundRedemption(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxFundApiMakeFundRedemption>>, TError, {data: FundRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxFundApiPendingSubscription = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PendingSubscriptionResponse>> => {
    return axios.get(
      `/Fund/pending-subscription`,options
    );
  }


export const getUtxFundApiPendingSubscriptionQueryKey = () => [`/Fund/pending-subscription`];

    
export type UtxFundApiPendingSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiPendingSubscription>>>
export type UtxFundApiPendingSubscriptionQueryError = AxiosError<unknown>

export const useUtxFundApiPendingSubscription = <TData = Awaited<ReturnType<typeof utxFundApiPendingSubscription>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiPendingSubscription>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiPendingSubscriptionQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiPendingSubscription>>> = ({ signal }) => utxFundApiPendingSubscription({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiPendingSubscription>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFundApiRedemptionList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RedemptionListResponse>> => {
    return axios.get(
      `/Fund/redemption-list`,options
    );
  }


export const getUtxFundApiRedemptionListQueryKey = () => [`/Fund/redemption-list`];

    
export type UtxFundApiRedemptionListQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiRedemptionList>>>
export type UtxFundApiRedemptionListQueryError = AxiosError<unknown>

export const useUtxFundApiRedemptionList = <TData = Awaited<ReturnType<typeof utxFundApiRedemptionList>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiRedemptionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiRedemptionListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiRedemptionList>>> = ({ signal }) => utxFundApiRedemptionList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiRedemptionList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFundApiCanRedemptionList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CanRedemptionListResponse>> => {
    return axios.get(
      `/Fund/can-redemption-list`,options
    );
  }


export const getUtxFundApiCanRedemptionListQueryKey = () => [`/Fund/can-redemption-list`];

    
export type UtxFundApiCanRedemptionListQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiCanRedemptionList>>>
export type UtxFundApiCanRedemptionListQueryError = AxiosError<unknown>

export const useUtxFundApiCanRedemptionList = <TData = Awaited<ReturnType<typeof utxFundApiCanRedemptionList>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiCanRedemptionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiCanRedemptionListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiCanRedemptionList>>> = ({ signal }) => utxFundApiCanRedemptionList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiCanRedemptionList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFundApiFundOpenAccount = (
    fundAccountRequest: FundAccountRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FundAccountRequestResponse>> => {
    return axios.post(
      `/Fund/open-account`,
      fundAccountRequest,options
    );
  }



    export type UtxFundApiFundOpenAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxFundApiFundOpenAccount>>>
    export type UtxFundApiFundOpenAccountMutationBody = FundAccountRequest
    export type UtxFundApiFundOpenAccountMutationError = AxiosError<unknown>

    export const useUtxFundApiFundOpenAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxFundApiFundOpenAccount>>, TError,{data: FundAccountRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxFundApiFundOpenAccount>>, {data: FundAccountRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxFundApiFundOpenAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxFundApiFundOpenAccount>>, TError, {data: FundAccountRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxFundApiFundOpenWmcAccount = (
    fundBondWmcAccountRequest: FundBondWmcAccountRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FundBondWmcAccountRequestResponse>> => {
    return axios.post(
      `/Fund/open-wmc-account`,
      fundBondWmcAccountRequest,options
    );
  }



    export type UtxFundApiFundOpenWmcAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxFundApiFundOpenWmcAccount>>>
    export type UtxFundApiFundOpenWmcAccountMutationBody = FundBondWmcAccountRequest
    export type UtxFundApiFundOpenWmcAccountMutationError = AxiosError<unknown>

    export const useUtxFundApiFundOpenWmcAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxFundApiFundOpenWmcAccount>>, TError,{data: FundBondWmcAccountRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxFundApiFundOpenWmcAccount>>, {data: FundBondWmcAccountRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxFundApiFundOpenWmcAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxFundApiFundOpenWmcAccount>>, TError, {data: FundBondWmcAccountRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxFundApiCalcFeeForUser = (
    params: UtxFundApiCalcFeeForUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CalcFeeForUserResponse>> => {
    return axios.get(
      `/Fund/calc-fee`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxFundApiCalcFeeForUserQueryKey = (params: UtxFundApiCalcFeeForUserParams,) => [`/Fund/calc-fee`, ...(params ? [params]: [])];

    
export type UtxFundApiCalcFeeForUserQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiCalcFeeForUser>>>
export type UtxFundApiCalcFeeForUserQueryError = AxiosError<unknown>

export const useUtxFundApiCalcFeeForUser = <TData = Awaited<ReturnType<typeof utxFundApiCalcFeeForUser>>, TError = AxiosError<unknown>>(
 params: UtxFundApiCalcFeeForUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiCalcFeeForUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiCalcFeeForUserQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiCalcFeeForUser>>> = ({ signal }) => utxFundApiCalcFeeForUser(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiCalcFeeForUser>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFundApiWmcFundFilter = (
    params?: UtxFundApiWmcFundFilterParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WmcFundFilterResponse>> => {
    return axios.get(
      `/Fund/wmc-fund-filter`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxFundApiWmcFundFilterQueryKey = (params?: UtxFundApiWmcFundFilterParams,) => [`/Fund/wmc-fund-filter`, ...(params ? [params]: [])];

    
export type UtxFundApiWmcFundFilterQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiWmcFundFilter>>>
export type UtxFundApiWmcFundFilterQueryError = AxiosError<unknown>

export const useUtxFundApiWmcFundFilter = <TData = Awaited<ReturnType<typeof utxFundApiWmcFundFilter>>, TError = AxiosError<unknown>>(
 params?: UtxFundApiWmcFundFilterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiWmcFundFilter>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiWmcFundFilterQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiWmcFundFilter>>> = ({ signal }) => utxFundApiWmcFundFilter(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiWmcFundFilter>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFundApiSecuritiesBalanceForUser = (
    params?: UtxFundApiSecuritiesBalanceForUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SecuritiesBalanceListResponse>> => {
    return axios.get(
      `/Fund/securities-balance-list`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxFundApiSecuritiesBalanceForUserQueryKey = (params?: UtxFundApiSecuritiesBalanceForUserParams,) => [`/Fund/securities-balance-list`, ...(params ? [params]: [])];

    
export type UtxFundApiSecuritiesBalanceForUserQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiSecuritiesBalanceForUser>>>
export type UtxFundApiSecuritiesBalanceForUserQueryError = AxiosError<unknown>

export const useUtxFundApiSecuritiesBalanceForUser = <TData = Awaited<ReturnType<typeof utxFundApiSecuritiesBalanceForUser>>, TError = AxiosError<unknown>>(
 params?: UtxFundApiSecuritiesBalanceForUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiSecuritiesBalanceForUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiSecuritiesBalanceForUserQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiSecuritiesBalanceForUser>>> = ({ signal }) => utxFundApiSecuritiesBalanceForUser(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiSecuritiesBalanceForUser>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFundApiGetSecuritiesBalanceForUser = (
    params?: UtxFundApiGetSecuritiesBalanceForUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CashPositionForSecuritiesBalanceListResponse>> => {
    return axios.get(
      `/Fund/cash-position`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxFundApiGetSecuritiesBalanceForUserQueryKey = (params?: UtxFundApiGetSecuritiesBalanceForUserParams,) => [`/Fund/cash-position`, ...(params ? [params]: [])];

    
export type UtxFundApiGetSecuritiesBalanceForUserQueryResult = NonNullable<Awaited<ReturnType<typeof utxFundApiGetSecuritiesBalanceForUser>>>
export type UtxFundApiGetSecuritiesBalanceForUserQueryError = AxiosError<unknown>

export const useUtxFundApiGetSecuritiesBalanceForUser = <TData = Awaited<ReturnType<typeof utxFundApiGetSecuritiesBalanceForUser>>, TError = AxiosError<unknown>>(
 params?: UtxFundApiGetSecuritiesBalanceForUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFundApiGetSecuritiesBalanceForUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFundApiGetSecuritiesBalanceForUserQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFundApiGetSecuritiesBalanceForUser>>> = ({ signal }) => utxFundApiGetSecuritiesBalanceForUser(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFundApiGetSecuritiesBalanceForUser>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

